import { Subtitle, Button as CustomButton } from "../styled";
import { useMissingData } from "./context";
import { cpfMask } from "utils/cpf";

import { Container, Flex, Key, Value } from "./styled";
import { Alert, Typography } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useMutation } from "@tanstack/react-query";
import api from "services/api";
import { useParams } from "react-router-dom";
import { useAlert } from "contexts/alert";

export function StepConfirmation() {
  const { workspaceActivityId, campaignId } = useParams() as { workspaceActivityId: string, campaignId: string };
  const { openAlert } = useAlert();
  const { data, handlePrevStep, handleNextStep } = useMissingData();

  const { isPending, isError, error, mutate } = useMutation({
    mutationFn: async () => {
      try {
        let parsed = { 
          ...data,
          employee_product_type: data.employee_product_type.join(", "),
          dependents: data.dependents.map(dependent => ({
            ...dependent,
            product_type: dependent.product_type.join(", ")
          })),
        };

        /** Caso selecionou que não tem dependentes, enviar lista de dependents como empty array. */
        if (data.dependent_product_type.includes("NONE")) {
          parsed = { ...parsed, dependents: [] };
        }

        console.log("!!!!! >> RESULT", parsed)
        await api.post(`/v2/forms/missing-data/${workspaceActivityId}/${campaignId}/result`, { payload: parsed });
        // await api.post(`forms/${orgId}/employee-data/?cpf=${data.tax_payer_id.replaceAll(".", "").replace("-", "")}&hash=${hash}`, parsed);
      } catch(err) {
        throw new Error("Algo deu errado ao enviar o formulário.");
      }
    },
    onSuccess: (data) => {
      openAlert('Formulário enviado com sucesso.', 'success');
      handleNextStep();
    },
    onError: (err) => {
      openAlert('Algo deu errado ao enviar o formulário.', 'error');
    },
  });

  function handlePrev() {
    /** Decide se retorna para primeiro step ou não de acordo se possui dependentes. */
    if (data.dependent_product_type.includes("NONE")) return handlePrevStep(0);

    handlePrevStep();
  }

  return (
    <>
      <Subtitle>Titular</Subtitle>
      <Container>
        <span style={{ fontWeight: "500" }}>Dados pessoais</span>
        <Flex>
          <Key>Nome completo sem abreviações</Key>
          <Value>{data.name}</Value>
        </Flex>
        <Flex>
          <Key>CPF</Key>
          <Value>{cpfMask(data.tax_payer_id)}</Value>
        </Flex>
        <Flex>
          <Key>RG</Key>
          <Value>{data.registration_number}</Value>
        </Flex>
        <Flex>
          <Key>Data de nascimento</Key>
          <Value>{data.birth_date}</Value>
        </Flex>
        <Flex>
          <Key>Gênero</Key>
          <Value>{data.gender_id}</Value>
        </Flex>
        <Flex>
          <Key>Estado civil</Key>
          <Value>{data.marital_status_id}</Value>
        </Flex>
        <Flex>
          <Key>Nome completo da mãe sem abreviações</Key>
          <Value>{data.mother_name}</Value>
        </Flex>
        <span style={{ fontWeight: "500", marginTop: "20px" }}>Endereço</span>
        <Flex>
          <Key>CEP</Key>
          <Value>{data.zip_code}</Value>
        </Flex>
        <Flex>
          <Key>Tipo do endereço</Key>
          <Value>{data.address_type}</Value>
        </Flex>
        <Flex>
          <Key>Endereço</Key>
          <Value>{data.address}</Value>
        </Flex>
        <Flex>
          <Key>Número</Key>
          <Value>{data.address_number}</Value>
        </Flex>
        <Flex>
          <Key>Complemento</Key>
          <Value>{data.complement}</Value>
        </Flex>
        <Flex>
          <Key>Bairro</Key>
          <Value>{data.neighborhood}</Value>
        </Flex>
        <Flex>
          <Key>Estado</Key>
          <Value>{data.state_id}</Value>
        </Flex>
        <Flex>
          <Key>Cidade</Key>
          <Value>{data.city_id}</Value>
        </Flex>
        <Flex>
          <Key>Código da cidade</Key>
          <Value>{data.city_number}</Value>
        </Flex>
        <span style={{ fontWeight: "500", marginTop: "20px" }}>Endereço</span>
        <Flex>
          <Key>Benefícios do titular</Key>
          {data.employee_product_type.includes("NONE") ? (
            <Value>Nenhum</Value>
          ) : (
            <Value>{data.employee_product_type.map(value => value === "HEALTH" ? "Saúde" : value === "LIFE" ? "Vida" : "Odonto").join(", ")}</Value>
          )}
        </Flex>
      </Container>
      {!data.dependent_product_type.includes("NONE") && !!data.dependents.length && (
        <>
          <Subtitle>Dependente(s)</Subtitle>
          <Container>
            {data.dependents.map((dependent, index) => (
              <>
                <span style={{ fontWeight: "500", marginTop: index === 0 ? "0px" : "50px" }}>Dependente {index + 1}</span>
                <Flex>
                  <Key>Nome completo sem abreviações</Key>
                  <Value>{dependent.name}</Value>
                </Flex>
                <Flex>
                  <Key>Tipo do dependente</Key>
                  <Value>{dependent.dependent_type_id}</Value>
                </Flex>
                <Flex>
                  <Key>Estado civil</Key>
                  <Value>{dependent.marital_status_id}</Value>
                </Flex>
                <Flex>
                  <Key>Nome completo da mãe sem abreviações</Key>
                  <Value>{dependent.mother_name}</Value>
                </Flex>
                <Flex>
                  <Key>CPF</Key>
                  <Value>{cpfMask(dependent.tax_payer_id)}</Value>
                </Flex>
                <Flex>
                  <Key>Data de nascimento</Key>
                  <Value>{dependent.birth_date}</Value>
                </Flex>
                <Flex>
                  <Key>Gênero</Key>
                  <Value>{dependent.gender_id}</Value>
                </Flex>
                <Flex>
                  <Key>Estudante</Key>
                  <Value>{dependent.student}</Value>
                </Flex>
                <Flex>
                  <Key>Benefícios do dependente</Key>
                  {dependent.product_type.includes("NONE") ? (
                    <Value>Nenhum</Value>
                  ) : (
                    <Value>{dependent.product_type.map(value => value === "HEALTH" ? "Saúde" : value === "LIFE" ? "Vida" : "Odonto").join(", ")}</Value>
                  )}
                </Flex>
              </>
            ))}
          </Container>
        </>
      )}
      <Alert
        icon={<InfoOutlinedIcon fontSize="inherit" />}
        severity="info"
        sx={{
          backgroundColor: '#eaf6fd',
          color: 'black',
          borderRadius: 3,
          alignItems: 'center',
        }}
      >
        <Typography variant="body2" component="span">
          Se todos os dados estiverem corretos aperte com <strong>"Confirmar e Enviar"</strong> e seus dados serão enviados
        </Typography>
      </Alert>
      <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
        <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
          <CustomButton
            variant="outlined"
            disabled={isPending}
            onClick={handlePrev}
            startIcon={<ChevronLeftIcon color="primary" style={{ height: "22px", marginLeft: "-8px"}} />}
          >
            Voltar
          </CustomButton>
          <CustomButton 
            variant="contained"
            disabled={isPending}
            onClick={() => mutate()}
            style={{ width: "200px"}}
          >
            {isPending ? "Enviando..." : "Confirmar e Enviar"}
          </CustomButton>
        </div>
      </div>
    </>
  )
}
